import { type AnimationControlValue, AnimationRadioGroup } from './AnimationRadioGroup';
import { repeatOptions, type AnimationRepeat } from './animationControlOptions';

type AnimationRepeatControlProps = {
    value?: AnimationControlValue<AnimationRepeat>;
    defaultValue?: AnimationControlValue<AnimationRepeat>;
    onChange?: (value: AnimationControlValue<AnimationRepeat>) => void;
};

const AnimationRepeatControl = (props: AnimationRepeatControlProps) => (
    <AnimationRadioGroup name='animation' options={repeatOptions} {...props} />
);

export default AnimationRepeatControl;
